import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Text from '../../../../assets/styles/Text';
import Arrow from '../../../../components/Arrow';
import Loader from '../../../../components/Loader';
import { useModelServices } from '../../../../hooks/queries/useModels';
import * as styles from './styles';

export default function Service() {
  const [show, setShow] = useState(true);
  const [showDescription, setShowDescription] = useState({});
  const { id } = useParams();
  const theme = useTheme();

  // Hook para buscar serviços da model
  const { data: servicesData, isLoading } = useModelServices(id);

  const services = servicesData?.services || [];
  const description = servicesData?.description || '';

  function renderServices(listenServices) {
    function chooseNumber(value) {
      let result = null;

      switch (value) {
        case 'NAO':
          result = 2;
          break;
        case 'SIM':
          result = 1;
          break;
        default:
          result = 3;
          break;
      }

      return result;
    }

    return listenServices?.map(({ service, optionType, serviceId }) => (
      <styles.Box key={serviceId}>
        <div>
          <Text.P $bold>{service.name}</Text.P>
          <Arrow
            show={showDescription?.[serviceId]}
            color={theme.colors.grey.white}
            size={16}
            func={() =>
              setShowDescription((prev) => ({
                ...prev,
                [serviceId]: !prev[serviceId],
              }))
            }
          />
        </div>

        {showDescription?.[serviceId] && <small>{service.description}</small>}

        <styles.BoxText $value={chooseNumber(optionType)}>
          <div>
            <div className="content" />
            <Text.Span>Sim</Text.Span>
          </div>

          <div>
            <div className="content" />
            <Text.Span>Não</Text.Span>
          </div>

          <div>
            <div className="content" />
            <Text.Span>Sim, com taxa adicional</Text.Span>
          </div>
        </styles.BoxText>
      </styles.Box>
    ));
  }

  return (
    <styles.Container id="service">
      <styles.Description>
        <Text.P>{description}</Text.P>
      </styles.Description>

      <styles.Top onClick={() => setShow((prevState) => !prevState)}>
        <Text.H3 $bold>Serviços</Text.H3>
        <Arrow show={show} color={theme.colors.primary.main} />
      </styles.Top>

      <styles.Grid $show={show}>
        {isLoading ? (
          <Loader isLoading={isLoading} minimal />
        ) : (
          renderServices(services)
        )}
      </styles.Grid>

      <Text.P $bold>
        Para mais informações entre em contato com o acompanhante pelo WhatsApp
      </Text.P>
    </styles.Container>
  );
}
